var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var IconWrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  vertical-align: text-top;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  ", ";\n  vertical-align: text-top;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_a) {
    var size = _a.size;
    return size && "height: " + size + "px;";
});
var templateObject_1;
